<template>
  <router-view name="main" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MainApp',
  metaInfo: {
    title: 'YYC',
    titleTemplate: '%s | Yoga Care',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: '',
      },
      {
        vmid: 'surveyStepTitle',
        name: 'surveyStepTitle',
        content: '',
      },
      {
        vmid: 'surveyStepType',
        name: 'surveyStepType',
        content: '',
      },
    ],
  },
  methods: {
    ...mapActions('shared', [
      'clearError',
      'clearSuccess',
      'clearInfo',
      'setMobile',
    ]),
  },
  watch: {
    error(newValue) {
      if (newValue) {
        this.$awn.alert(newValue)
      }
      this.clearError()
    },
    success(newValue) {
      if (newValue) {
        this.$awn.success(newValue)
      }
      this.clearSuccess()
    },
    info(newValue) {
      if (newValue) {
        this.$awn.info(newValue)
      }
      this.clearInfo()
    },
  },
  computed: {
    ...mapGetters('shared', ['error', 'success', 'info']),
  },
  created() {
    this.setMobile(window.innerWidth <= 980)
    addEventListener('resize', () => {
      this.setMobile(innerWidth <= 980)
    })
  },
}
</script>

<style>
@import '@/assets/css/kirill.css';
@import '@/assets/css/init.css';

.add-pointer {
  cursor: pointer;
}
.remove-pointer {
  cursor: default;
}
.socials__link {
  cursor: pointer;
}
/* @media (max-width: 767px) {

  .app-shell {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
  .header {
    padding-top: env(safe-area-inset-top);
    height: calc(
      55px + env(safe-area-inset-top)
    ); 
  }
  .helper {
    padding-top: calc(55px + env(safe-area-inset-top));
  }
  .burger-menu__closer {
    top: calc(16px + env(safe-area-inset-top));
  }
  .questionnaire__header {
    padding-top: calc(16px + env(safe-area-inset-top));
  }
  .kirill_container_new_text_pay {
    padding-top: calc(40px + env(safe-area-inset-top));
  }
  .kirill_container_new_text_pay {
    padding-top: calc(40px + env(safe-area-inset-top));
  }
  .kirill_link_cross {
    top: calc(16px + env(safe-area-inset-top));
  }
} */
:root {
  --sat: env(safe-area-inset-top, 0px);
  --sab: env(safe-area-inset-bottom, 0px);
  --sal: env(safe-area-inset-left, 0px);
  --sar: env(safe-area-inset-right, 0px);
}

/* iOS/общие стили — как у тебя, но через переменные */
@media (max-width: 767px) {
  .app-shell {
    padding-top: var(--sat);
    padding-bottom: var(--sab);
    padding-left: var(--sal);
    padding-right: var(--sar);
  }
  .header {
    padding-top: var(--sat);
    height: calc(55px + var(--sat));
  }
  .helper {
    padding-top: calc(55px + var(--sat));
  }
  .burger-menu__closer {
    top: calc(16px + var(--sat));
  }
  .questionnaire__header {
    padding-top: calc(16px + var(--sat));
  }
  .kirill_container_new_text_pay {
    padding-top: calc(40px + var(--sat));
  }
  .kirill_link_cross {
    top: calc(16px + var(--sat));
  }
}

/* Вьюпорт-юниты без прыжков на мобилках */
.full-height-section {
  min-height: 100dvh; /* вместо 100vh */
}
</style>
